export const termsAndConditionsContent = [
  {
    title: "1. Agreement to Terms",
    text: "By accessing or using our services, you agree to be bound by these Terms & Conditions and applicable laws. If you do not agree with any part of these terms, you may not use our services.",
  },
  {
    title: "2. Use of Services",
    text: "You agree to use our services only for lawful purposes and not engage in activities that may harm our systems, business, or other users. This includes but is not limited to unauthorized access, data scraping, or malicious activities.",
  },
  {
    title: "3. Intellectual Property",
    text: "All content, branding, visuals, code, and materials on this website and in our services are owned by or licensed to O3S unless otherwise stated. You may not reproduce, distribute, or modify any content without express written permission.",
  },
  {
    title: "4. Payment & Fees",
    text: "Payment terms for services are defined separately in proposals, contracts, or invoices. Failure to pay invoices may result in suspension or termination of services.",
  },
  {
    title: "5. Limitation of Liability",
    text: "O3S is not liable for indirect, incidental, special, consequential, or punitive damages arising from the use or inability to use our services, even if advised of the possibility of such damages.",
  },
  {
    title: "6. Termination",
    text: "We may suspend or terminate services if these terms are violated, if payment is not received, or if necessary for operational or legal reasons. Upon termination, access to services will be immediately revoked.",
  },
  {
    title: "7. Changes to Terms",
    text: "We reserve the right to modify these Terms & Conditions at any time. Changes will be effective immediately upon posting. Your continued use of our services constitutes acceptance of modified terms.",
  },
  {
    title: "8. Confidentiality",
    text: "Both parties agree to maintain confidentiality of any proprietary or sensitive information shared during the course of our engagement, unless otherwise specified in a separate agreement.",
  },
  {
    title: "9. Disclaimers",
    text: "Our services are provided on an 'as-is' basis. We make no warranties, express or implied, regarding the quality, accuracy, or fitness of our services for any particular purpose.",
  },
];
